import BaseService from '../../BaseService.js';

export default class WohnanlageService extends BaseService {

  constructor(wohnobjektId) {
    super(`wohnobjekte/${wohnobjektId}/wohnanlage`)
  }
}
